import { createListQuery } from './listQuery';
import { normalizeGridResult, serializeListQuery } from './kendoAdapter';
import { ACTIVE_GRID_TRANSPORT } from './listQuery';

/**
 * Fetch one page using the neutral ListQuery (mapped for current API).
 * @param {(body: object) => Promise<any>} apiFn MainService.*InGrid
 * @param {import('./listQuery').ListQuery} listQuery
 * @param {{ transport?: string }} [options]
 * @returns {Promise<{ data: any[], total: number }>}
 */
export const fetchGridPage = async (apiFn, listQuery, options = {}) => {
  const transport = options.transport || ACTIVE_GRID_TRANSPORT;
  const body = serializeListQuery(listQuery, transport);
  const response = await apiFn(body);
  return normalizeGridResult(response);
};

/**
 * Load the full dataset for client-side master grids.
 * Uses a probe request for Total, then one Take=total request.
 * When ACTIVE_GRID_TRANSPORT becomes 'neutral', this still works unchanged.
 *
 * @param {(body: object) => Promise<any>} apiFn
 * @param {{ minTake?: number, transport?: string }} [options]
 */
export const loadAllGridRows = async (apiFn, options = {}) => {
  const minTake = options.minTake ?? 100;
  const transport = options.transport || ACTIVE_GRID_TRANSPORT;

  const probe = await fetchGridPage(
    apiFn,
    createListQuery({ skip: 0, take: 1 }),
    { transport }
  );

  const take = Math.max(probe.total || 0, minTake);
  if (take <= 1 && probe.data.length <= 1 && probe.total <= 1) {
    return probe;
  }

  return fetchGridPage(
    apiFn,
    createListQuery({ skip: 0, take }),
    { transport }
  );
};
